import React from 'react'
import Header from '../../Components/Modules/Includes/Header'
import { Row,Col } from 'react-bootstrap'
import RaisedButton from 'material-ui/RaisedButton';
import LinearProgress from 'material-ui/LinearProgress';
import TextField from 'material-ui/TextField';
import _ from 'lodash';
import CircularProgress from 'material-ui/CircularProgress';
import JobDetails from './JobDetails';
import ReactPaginate from 'react-paginate';

import { connect } from 'react-redux';
import * as actions from '../../Actions/index.js';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import Modal from 'react-modal';
import Moment from 'react-moment';
import { Route, withRouter } from 'react-router-dom';
import { AlertList } from "react-bs-notifier";
import {Helmet} from "react-helmet";
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import {Link} from 'react-router-dom'
import moment from 'moment';

Modal.setAppElement('#root')

class Job extends React.Component{
  
  constructor(props) {
	    super(props);
	    this.filterToggle = this.filterToggle.bind(this);
	    this.state = {
	    	open: false,
	    	completed: 0,
	    	filter: 'active-dashboard',
        currentPage : 1,
        searchData : "",
	    	jobSortIndex: 0,
	      	jobSortByIdDirection: false,
	      	jobSortBySiteDirection: false,
	      	jobSortByStatusDirection: false,
	      	jobSortByImportDirection: true,
          jobSearchText: '',
	      	jobs: [],
	      	modalIsOpen: false,
	      	authorizeModal: true,
	      	jobIdrequired: false,
	      	importJobId: '',
	      	alerts: [],
	      	selectCompanyReq: '',
	      	value: -1,
	      	tokenstatus: null,
	      	authorizeLoader: true,
          jobSortBy : 'importedat',
          simpro_name_req:'',
          simpro_pass_req:'',
          simproUsername:'',
          simproPassword:'',
        current_sort_by:'simpro_id',
        current_order:1
	    }

			this.toastsDisplayed = [];
			this.openJob = this.openJob.bind(this);
			this.jobSearchTextChange = this.jobSearchTextChange.bind(this);
			this.jobSortBy = this.jobSortBy.bind(this);
			this.openModal = this.openModal.bind(this);
			this.closeModal = this.closeModal.bind(this);
			this.changeJobId = this.changeJobId.bind(this);
			this.importJob = this.importJob.bind(this);
			this.closeModalPopup= this.closeModalPopup.bind(this);
			this.dissmissAlert= this.dissmissAlert.bind(this);
			this.updateFromFreetrial = this.updateFromFreetrial.bind(this);
			this.authorize = this.authorize.bind(this);
			this.closeAuthorizePopup = this.closeAuthorizePopup.bind(this);
	  }
	  handleChange2 = (event, index, value) => this.setState({value:value});
	  openModal() {
		this.setState({modalIsOpen: true});
	  }
	  closeModal() {
	    this.setState({modalIsOpen: false});
	  }
	  closeModalPopup(){
	  	this.setState({modalIsOpen: false});
	    this.props.resetJobImportPopup();
	  }
	  filterToggle(){
			let value =  (this.state.filter === 'active-dashboard') ? 'deactivate-dashboard' : 'active-dashboard' 
		  	this.setState({ filter : value });
	  }
	  componentDidMount() {
      const query = new URLSearchParams(this.props.location.search);
      let urlParm = query.get('allowJobImp');
      sessionStorage.removeItem(urlParm);
      if(urlParm){
        console.log("url==>", window.location.origin + window.location.pathname);
        setTimeout(() => {
          window.location.href = window.location.origin + window.location.pathname;
        }, 1000);
      }

      let compId = this.props.userdetail.companydetail 
      ? this.props.userdetail.companydetail.company_id
      : '';
	  	if(compId){
	  		 this.props.resetJobReimportPopup();
	  		 this.props.fetchJobs(compId);
	  		 this.props.getCompaniesFromApi(compId);
	  		 this.props.fetchManuals(compId);
	  		 this.props.getTemplateSet(compId);
	  	}
	  }
	  componentWillMount(){
	  	const tokenStatus = window.localStorage.getItem('tokenStatus');
	  	this.setState({tokenstatus: tokenStatus}); 
	  	let compId= this.props.userdetail.companydetail?this.props.userdetail.companydetail.company_id:'';
	  	if(compId){
	  		 this.props.fetchManuals(compId);
	  	}
	  }

  handlePageClick = (data) => {
    let selected = data.selected;
    let offset = Math.ceil(selected * this.props.perPage);
    this.setState({ currentPage: selected+1 });
    this.setState({ offset: offset }, () => {
      
      let compId = this.props.userdetail.companydetail
        ? this.props.userdetail.companydetail.company_id + `?current_page=${this.state.currentPage}&search=${this.state.jobSearchText}&sort=${this.state.current_sort_by}&order=${this.state.current_order}`
        : '';
      if (compId) {
        this.props.fetchJobs(compId);
      }
    });
  };
  
  handleJobSearch = (event) => {
    this.setState({ jobSearchText: event.target.value }); 

    let selected = 0;
    this.setState({ currentPage: 1});
    let offset = Math.ceil(selected * this.props.perPage);
    this.setState({ offset: offset }, () => {
      
      let compId = this.props.userdetail.companydetail
        ? this.props.userdetail.companydetail.company_id + `?search=${this.state.jobSearchText}&current_page=1&sort=${this.state.current_sort_by}&order=${this.state.current_order}`
        : '';
      if (compId) {

        this.props.fetchJobs(compId);
      }
    });
    if(document.querySelector(".pagination")){
      document.querySelector(".pagination").children[1].children[0].click();
    }
  };

	  updateFromFreetrial(){
	  	let compId= this.props.userdetail.companydetail?this.props.userdetail.companydetail.company_id:'';
	    this.props.updateFromFreetrial(compId);
	  }
	  openJob(job) {
	    this.props.history.push(`/job/${job.simpro_id}`);
	  }
	  jobSearchTextChange(event) {
	    this.setState({ jobSearchText: event.target.value }); 
	  }
	  jobSortBy(sortby) {
	  	let order = '';
      let selected = 0;
      let offset = Math.ceil(selected * this.props.perPage);
      let compId = '';
      switch(sortby){
	  		case 'jobid':
          // this.setState({ jobSearchText: event.target.value }); 
          order = this.state.jobSortByIdDirection?-1:1;
          this.setState({ currentPage: 1, current_sort_by:'simpro_id', current_order : order});
          this.setState({ offset: offset }, () => {
            console.log("Selected", selected);
            compId = this.props.userdetail.companydetail
              ? this.props.userdetail.companydetail.company_id + `?search=${this.state.jobSearchText}&current_page=1&sort=simpro_id&order=${order}`
              : '';
            if (compId) {

              this.props.fetchJobs(compId);
            }
          });
          // console.log("this.state.jobSortByIdDirection", order);
	  			this.setState({jobSortBy: sortby, jobSortByIdDirection : !this.state.jobSortByIdDirection }); 
	  			break;
	  		case 'site':
          order = this.state.jobSortBySiteDirection?-1:1;
          this.setState({ currentPage: 1, current_sort_by:'site', current_order : order});
          this.setState({ offset: offset }, () => {
            console.log("Selected", selected);
            compId = this.props.userdetail.companydetail
              ? this.props.userdetail.companydetail.company_id + `?search=${this.state.jobSearchText}&current_page=1&sort=site&order=${order}`
              : '';
            if (compId) {

              this.props.fetchJobs(compId);
            }
          });
	  			this.setState({ jobSortBy: sortby, jobSortBySiteDirection : !this.state.jobSortBySiteDirection }); 
	  			break;
	  		case 'status':
          order = this.state.jobSortByStatusDirection?-1:1;
          this.setState({ currentPage: 1, current_sort_by:'status', current_order : order});
          this.setState({ offset: offset }, () => {
            console.log("Selected", selected);
            compId = this.props.userdetail.companydetail
              ? this.props.userdetail.companydetail.company_id + `?search=${this.state.jobSearchText}&current_page=1&sort=status&order=${order}`
              : '';
            if (compId) {

              this.props.fetchJobs(compId);
            }
          });
	  			this.setState({ jobSortBy: sortby, jobSortByStatusDirection : !this.state.jobSortByStatusDirection }); 
	  			break;
	  		case 'importedat':
          order = this.state.jobSortByImportDirection?-1:1;
          this.setState({ currentPage: 1, current_sort_by:'imported_at', current_order : order});
          this.setState({ offset: offset }, () => {
            console.log("Selected", selected);
            compId = this.props.userdetail.companydetail
              ? this.props.userdetail.companydetail.company_id + `?search=${this.state.jobSearchText}&current_page=1&sort=imported_at&order=${order}`
              : '';
            if (compId) {

              this.props.fetchJobs(compId);
            }
          });
	  			this.setState({ jobSortBy: sortby, jobSortByImportDirection : !this.state.jobSortByImportDirection }); 
	  			break;
	  		//default : 

	  	}
      if(document.querySelector(".pagination")){
        document.querySelector(".pagination").children[1].children[0].click();
      }
       
	  }
	  changeJobId(e){ 
	    this.setState({
	      importJobId: e.target.value
	    });
	  }
	  importJob(e) {
	    e.preventDefault();
	    let simprocompanyId=this.state.value;
	    if(simprocompanyId=== -1){
	    	this.setState({selectCompanyReq:'Please select any company.'});
	    }
	    else{
	    	this.setState({selectCompanyReq:''});
	    	let simpro_comapany_id= this.state.value;
		    let companyId =  this.props.currentuser.currentUser ? this.props.currentuser.company._id : '';
        
        let importingJob = sessionStorage.getItem(this.state.importJobId)
        console.log("importingJob", importingJob);
        if(importingJob){
          let alerts = [{
            type: 'warning',
            message: 'Your job is already importing!.'
          }]
          this.setState({alerts:alerts})
          return true;
        }
	    	this.props.importJob(this.state.importJobId,companyId,simpro_comapany_id, this.props.history);
        
        sessionStorage.setItem(this.state.importJobId, this.state.importJobId)
        
	    }
	  }
	  componentWillReceiveProps(newProps) {
	  	let companiesList=this.props.jobs.companiesApi ? this.props.jobs.companiesApi: '';
	    if(companiesList.length===1){
	    	this.setState({value:0})
	    }
	    if( newProps.importedJobId && newProps.importedJobId !== this.props.importedJobId ) {
	      window.setTimeout(() => {
	      	this.setState({modalIsOpen: false});
	      	this.props.history.push(`/job/${newProps.importedJobId}`);
	    	if(newProps.jobs.check === 'reimport'){
	    		this.props.resetJobImportPopup();
	    		this.props.fetchLoginUserDetail();
	    	}	
	    	this.closeModalPopup()        
	      }, 2500);
	      
	    }
		window.setTimeout(()=>{
			if(this.props.jobs.tokenStatus === 1){
				this.setState({modalIsOpen: false})
			}
			const tokenStatus = window.localStorage.getItem('tokenStatus');
			this.setState({tokenstatus: tokenStatus}); 
	    },100)
	    
	  }
	  dissmissAlert(){
	  	this.setState({alerts: []});
	  	this.toastsDisplayed=[];
	  	this.props.unsetAllertMsg();
	  }
	  renderJobs() {
      
	    if(this.props.jobs.tokenStatus === 1 || !this.props.jobs || !this.props.jobs.items || this.props.jobs.items.length === 0 ) {
	      return null;
	    }

      
	    let jobs = _.clone(this.props.jobs.items);
	    if( this.state.jobSearchText ) {
	      jobs = _.filter(jobs, (job) => {
	        if( job.simpro_id.toString().indexOf(this.state.jobSearchText) !== -1 ) {
	          return true;
	        }
	        return false;
	      });
	    }
	    // if( this.state.jobSortBy ) {
	    // 	let filterBy = this.state.jobSortBy;
	    // 	switch(filterBy){
	    // 		case 'jobid':
	    // 			jobs.sort((a, b) => {
	    // 			  // return this.state.jobSortByIdDirection ? b.simpro_id - a.simpro_id : a.simpro_id - b.simpro_id;
	    // 			});
	    // 			break;
	    // 		case 'site':
	    // 			jobs = _.sortBy(jobs, [function(o) { return o.simpro_job.Site.SiteName; }]);
	    // 			if(this.state.jobSortBySiteDirection === false ){
	    // 				jobs = jobs.reverse();
	    // 			}
	    // 			break;
	    // 		case 'status':
	    // 			jobs = _.sortBy(jobs, [function(o) { return o.status; }]);
	    // 			if(this.state.jobSortByStatusDirection === false ){
	    // 				jobs = jobs.reverse();
	    // 			}
	    // 			break;
	    // 		case 'importedat':
	    // 			jobs.sort((a, b) => {
	    // 			  return this.state.jobSortByImportDirection? new Date(b.imported_at) - new Date(a.imported_at) : new Date(a.imported_at) - new Date(b.imported_at);
	    // 			});
	    // 			break;
	    // 		default : 
		  //   		jobs.sort((a, b) => {
		  //   		  return this.state.jobSortByImportDirection? new Date(b.imported_at) - new Date(a.imported_at) : new Date(a.imported_at) - new Date(b.imported_at);
		  //   		});
		  //   		//jobs = _.sortBy(jobs, [function(o) { return o.imported_at; }]);
		  //   		break;
	    // 	}
	    // }
	    if(jobs.length != 0){
		    return jobs.map((j, i) => {
		      let siteName = _.has(j, 'simpro_job.Site.SiteName') ? j.simpro_job.Site.SiteName : '';
          
		      if (sessionStorage.getItem(j.simpro_id) !== null && window.location.pathname == '/job') {
            sessionStorage.removeItem(j.simpro_id);
          }
          return (
		        !Number.isNaN(j.simpro_id) && <tr key={`job${j.simpro_id}`} onClick={() => { this.openJob(j); }}>
              <td data-title="Job Id">{j.simpro_id}</td>
              <td data-title="Site">{siteName}</td>
              <td data-title="Status">{j.status}</td>
              <td data-title="Imported at">
                <Moment format=" MMM-DD-YYYY , hh:mm a">
                  {j.imported_at}
                </Moment>
              </td>
              <td data-title="Sent to simPRO?" className="last-child">
                <input type="checkbox" value="" defaultChecked={j.sent_to_simpro ? true : false} className="checkboxs" />
                <span></span>
              </td>
              <td data-title="Manual Created?">
                <input type="checkbox" value="" defaultChecked={j.pdf_created_at ? true : false} className="checkboxs" />
                <span></span>
              </td>
            </tr>
		      );
		    });
		}else{
			return (
				<tr><td colspan="6">No Any Job Found</td></tr>
			)
		}
	  }
	  companiesList(){
	    let companiesList=this.props.jobs.companiesApi ? this.props.jobs.companiesApi: '';
	    if(companiesList.length===1 && this.state.value!=0){
	    	this.setState({value:0})
	    }else{
	    	return _.map(companiesList, (item) => {
		        return (
		          <MenuItem key={item.CompanyID} value={item.CompanyID} primaryText={item.CompanyName} />
		        );
		      });
	    }
	  }
	  authorize() {
	  	const {currentuser, jobs} = this.props;
	  	let check = true;
	  	if(jobs.tokenStatus === 1){
	  		this.setState({authorizeModal: false});
		  	let companyId = jobs.companyData ? jobs.companyData.companyId: '';
		  	let url = jobs.companyData ? jobs.companyData.simpro_url: '';
		  	let simprouser = jobs.companyData ? jobs.companyData.simpro_user: '';
		  	let simpropass = jobs.companyData ? jobs.companyData.simpro_pas: '';
		  	this.props.authorizeApi(companyId,url,simprouser,simpropass,check);
	  	}
	  	else{
	  		let companyId = this.props.userdetail.companydetail?this.props.userdetail.companydetail.company_id:'';
	  		let url = this.props.currentuser.company ? this.props.currentuser.company.simpro_url : '';
	  		let simprouser = this.props.currentuser.company ? this.props.currentuser.company.simprouser : '';
	  		let simpropass = this.props.currentuser.company ? this.props.currentuser.company.simpropass : '';
	  		this.props.authorizeApi(companyId,url,simprouser,simpropass,check); 
	  	}
	  }

	  closeAuthorizePopup(){
	  	this.setState({authorizeModal: false});
	  	window.location.href = '/job'
    }
    
    authorizeApi = (e) =>{
      let simprouser=this.state.simproUsername;
      let simpropass=this.state.simproPassword;
  
      if(simprouser.includes('@')){
        this.setState({simpro_name_req: "Pleae enter your Simpro username.",buttonDisable: false});
        return false;
      }
      if(simprouser===''){
        this.setState({simpro_name_req: "Please enter your simpro's user name.",buttonDisable: false});
        return false;
      }else{
      this.setState({simpro_name_req: ''});
      }
      if(simpropass===''){
      this.setState({simpro_pass_req: "Please enter your simpro's Password.",buttonDisable: false});
      return false;
      }else{
      this.setState({simpro_pass_req: ''});
      }
      let compId = this.props.currentuser && this.props.currentuser.company && this.props.currentuser.company._id;
      this.props.updateSimproDetails(simprouser,simpropass, compId,()=>{})
    }
    simPROpassword = (e)=>{
      let simpropass= e.target.value;
      this.setState({simproPassword: simpropass});
      }
    simPROUser = (e) =>{
    let simprouser= e.target.value;
    this.setState({simproUsername: simprouser});
    }
    cancelSimproUpdate = ()=>{
      this.props.cancelSimproUpdate()
    }

    handleFocus = (e) =>{
      if (e.target.hasAttribute('readonly')) {
        e.target.removeAttribute('readonly');
        e.target.blur();
        e.target.focus();  
      }
    }

    render() {
      let alerts = [{
              type: 'success',
              message: this.props.jobs.successMessage || 'Job updated successfully.'
      }]
      let subs_created_date = this.props.currentuser.companydetail ? this.props.currentuser.companydetail.subs_created_date : null;
      let subs_end_date = this.props.currentuser.companydetail ? this.props.currentuser.companydetail.subs_end_date : null;
      let subs_amount = this.props.currentuser.companydetail ? this.props.currentuser.companydetail.subs_amount : 0;
      let subs_paid = this.props.currentuser.companydetail ? this.props.currentuser.companydetail.subs_paid : null;
      let subs_allowance = this.props.currentuser.companydetail ? this.props.currentuser.companydetail.subs_allowance : 0;

      var timeDiff = Math.abs(new Date(subs_end_date).getTime() - new Date(subs_created_date).getTime());
      var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
      let checkalert = this.props.subscriptionPlan.free_trial_end;
      let plan =this.props.subscriptionPlan.plans.subscription;
      
      var trial_period_days;
      if(plan){
        // trial_period_days=plan[0].trial_period_days;
        trial_period_days = diffDays;
      }
      let startDate = moment(subs_created_date).add('days', trial_period_days);
      let timeEnd = moment(new Date());
      let diff = startDate.diff(timeEnd);
      let diffDuration = moment.duration(diff);
      let months = diffDuration.months() > 0 ? diffDuration.months() + ' month ' : '';
      var alertmsg='',alertlink='';
      if( subs_allowance<1){
        alertmsg= 'You have reached your project quota. Start your subscription now';
      }else{
        let type = this.props.currentuser.loggedInUser.type;
        if(type === 1){
          alertlink=<span><strong><Link to="/company">See subscription details</Link></strong></span>;
          }
          alertmsg= 'Your Dokkit trial expires in '+ months + diffDuration.days()+' days. ';
      }
        let check= _.indexOf(this.toastsDisplayed, 'job updated') === -1;
        if(check && this.props.jobs.successMessage){
          this.toastsDisplayed.push('job updated');
          this.setState({alerts:alerts});
        }
        let companiesList=this.companiesList();

        let jobs = this.renderJobs();
        const action = [
          <FlatButton
            label="Cancel"
            primary={true}
            onClick={this.closeModalPopup}
          />,
          <RaisedButton
            label="Import Job"
            primary={true}
            labelStyle={{'color': '#fff'}}
            keyboardFocused={true}
            type='Submit'
            onClick={this.importJob}
          />,

        ];
        const action1 = [
          <FlatButton
            label="Cancel"
            primary={true}
            onClick={this.closeAuthorizePopup}
          />,
          <RaisedButton
            label="Authorize"
            primary={true}
            labelStyle={{'color': '#fff'}}
            keyboardFocused={true}
            type='button'
            onClick={this.authorize}
            disabled = {this.props.signup.disableaAuthorizeButton === true? true: false}
          />
        ]
      return(
      <div>
        <Helmet>
          <meta charSet="utf-8" />
          <title>Job</title>
          <link rel="stylesheet" type="text/css" href="/css/table.css" />
        </Helmet>
        <AlertList alerts={this.state.alerts} timeout={4000} dismissTitle="close" showIcon={true} onDismiss={this.dissmissAlert} />
        <Header />        		  
        <Route path={`${this.props.match.url}/:jobId`} component={JobDetails}/>
        <Route exact path={this.props.match.url} render={() => (
          <div className="dashboard-page">
            <div className={`right-content-dashboard ${this.state.filter}`}>
              {!checkalert && subs_amount == null?
                <div className="alert alert-warning custom-alert">
            {alertmsg} {alertlink}
            {subs_allowance < 1 
            ? <button type="button" className="start-button" onClick={this.updateFromFreetrial}> Start Now </button>
            : null}
          </div>
        : null}
        {this.state.tokenstatus === '1' 
        ? <div className="alert alert-warning custom-alert">
            Your simPRO access has expired.
            <button type="button" className="start-button" onClick={this.authorize} >Re-authorize</button>
          </div> 
        : null}
        <div className="dashboard-content-sec table-dashboard">
          <Row className="display-flex padd30">
            <Col sm={3} xs={6}>
              <TextField
                fullWidth={ true }
                floatingLabelText="Search..."
                type="text"
                margin="0px"
                onChange={this.handleJobSearch}
                // onChange={this.jobSearchTextChange}
                value={this.state.jobSearchText}
              />
            </Col>
            <Col  sm={3} className="hidden-xs"></Col>
            <Col sm={6} xs={6} className="text-right">
            <RaisedButton
              label="Import Job"
              primary={true}
              labelStyle={{'color': '#fff'}}
              keyboardFocused={true}
              onClick={this.openModal}
            />
            </Col>
          </Row>	
          <div className="dashboard-table-data">
            <table id="example" className="responsive-table table-striped table-bordered dashboard-table" cellPadding="0" cellSpacing="0" width="100%">
              <thead>
                <tr>
                  <th>Job Id <a onClick={(e) => this.jobSortBy('jobid')}><i style={{"padding":"5px"}} className="zmdi zmdi-unfold-more"></i></a></th>
                  <th>Site <a onClick={(e) => this.jobSortBy('site')}><i style={{"padding":"5px"}} className="zmdi zmdi-unfold-more"></i></a></th>
                  <th>Status <a onClick={(e) => this.jobSortBy('status')}><i style={{"padding":"5px"}} className="zmdi zmdi-unfold-more"></i></a></th>
                  <th>Imported at <a onClick={(e) => this.jobSortBy('importedat')}><i style={{"padding":"5px"}} className="zmdi zmdi-unfold-more"></i></a></th>
                  <th  className="last-child">Sent to simPRO?</th>
                  <th>Manual Created?</th>
                </tr>
              </thead>
              <tbody>
                {jobs}
              </tbody>
              
            </table>
                    {(this.props.jobs && this.props.jobs.pagination) ? < ReactPaginate
                    previousLabel={'previous'}
                    nextLabel={'next'}
                    breakLabel={'...'}
                    breakClassName={'break-me'}
                    // initialPage={this.props.jobs.pagination.current_page}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    pageCount={this.props.jobs.pagination.last_page}
                    onPageChange={this.handlePageClick}
                    containerClassName={'pagination'}
                    activeClassName={'active'}
                />: null
              
              }
                
          </div>
          {!this.props.isImporting?
            !this.props.success?
            <Dialog 
              actions={action}
              className="model-support"
              modal={false}
              contentClassName="model-top-overlay no-overlay"
              open={ this.state.modalIsOpen}
              onRequestClose={this.closeModal}
            >       
              <div className="other-popup-content learn-more-popup">
                <form className="import-job-modal" onSubmit={this.importJob}>
                <h2 ref={subtitle => this.subtitle = subtitle}>Enter a Job ID to import from simPRO</h2>
                            
              <Row>
                <Col md={12}>
                  <SelectField
                    onChange={this.handleChange2}
                    name="selectCompany"
                    value={this.state.value}
                    errorText={this.state.selectCompanyReq}
                    floatingLabelText="Select company"
                    floatingLabelFixed={true}
                    hintText="Company"
                    fullWidth={ true }
                  >
                      {companiesList}
                  </SelectField>
                                
                </Col>
                <Col md={12}>
                      <TextField
                        fullWidth={ true }
                        floatingLabelText="Enter job id"
                        floatingLabelFixed={true}
                        name='jobId'
                        type='text'
                        value={this.state.importJobId} 
                        hintText="Job Id"
                        onChange={this.changeJobId}
                    />
                </Col>
              </Row>
                                        
              <Row>
                  <Col md={12}  className="margb20px">
                      { this.props.errorMessage ?
                        <p style={{color:'red'}}>{this.props.errorMessage}</p>
                        :
                        null
                      }
                  </Col>
                </Row>
            </form>
          </div>
        </Dialog>
        : <Dialog 
            className="model-support"
            modal={false}
            contentClassName="model-top-overlay no-overlay"
            open={this.state.modalIsOpen}
            onRequestClose={this.closeModal}
          >
            <div style={{float: 'right',padding: '5px',margin: '-16px', cursor: 'pointer'}} onClick={this.closeModalPopup} > <img src="/images/cross.svg"  alt="logo" /></div>
            <Row>
              <Col md={12}>
                <p className="success-msg" style={{textAlign: 'center'}}>
                  <span>
                    <img src="/images/green.png" height="50" width="50"  alt="imported img" />
                  </span>
                  <span className="success-text">
                    <p>Your job is importing, you will receive an email when complete.</p>
                    {(!_.isEmpty(this.props.failedAttachments) || !_.isEmpty(this.props.failedAttachments)) ?
										<p className="file-error-note">Note: If these files are needed please remove protection and re-import</p> : ""}
                  </span>
                </p>
                {(!_.isEmpty(this.props.failedAttachments) || !_.isEmpty(this.props.failedAttachments)) ?
										<div className="errorlist-wrap">
										{!_.isEmpty(this.props.failedAttachments) && <h3 className="err-heading" >Failed Attachments :</h3>}
										<ul>
										{this.props.failedAttachments && _.map(this.props.failedAttachments,(filesattach,i)=>{
											return <li className="error-msg">{filesattach}</li>
										})}
										</ul>
										{!_.isEmpty(this.props.failedStockAttachments) && <h3 className="err-heading" >Failed Stock Attachments :</h3>}
										<ul>
										{this.props.failedStockAttachments && _.map(this.props.failedStockAttachments,(files,i)=>{
											return <li className="error-msg" >{files}</li>
										})}
										</ul>
										</div>
										:""}
              </Col>
            </Row>
          </Dialog>
        : <Dialog
            className="model-support"
            modal={false}
            open={ this.state.modalIsOpen}
            onRequestClose={this.closeModal}
            contentClassName="model-top-overlay no-overlay"
          >
            <Row>
              <Col md={12}>
              <div style={{textAlign: 'center'}} onClick={this.closeModal} >
                <div className="progressbar1">
                  <LinearProgress mode="indeterminate" />
                </div>
                <p>Your job is being imported...</p>
              </div>
              </Col>
            </Row>
          </Dialog>}
          {
            this.props.simproAuthenticationFailed ? 
            <Dialog
            actions={[
              <FlatButton
                label="Cancel"
                primary={true}
                onClick={this.cancelSimproUpdate}
              />,
              <RaisedButton 
                type='Submit' 
                label={this.props.simproUpdating?<CircularProgress size={32} color="#fff"/>:"Update"} 
                onClick = {this.authorizeApi} 
                labelColor="#fff"  />,
            ]}
              className="model-support"
              modal={false}
              open={this.props.simproAuthenticationFailed}
              // onRequestClose={this.closeModalReimport}
              contentClassName="model-top-overlay no-overlay"
            >
              <Row>
                <Col md={12}>
                  <div style={{ textAlign: 'center' }}>
                    <Row>
                                          <form name="simpro-details-update" onSubmit={(e)=>{e.preventDefault()}} >
                                              <Col md={12}>
                                                <Row>
                                                  <Col md={12}>
                                                    <h2 className='simpro-login-heading'>SIMPRO LOGIN UPDATE</h2>
                                                    <p className='simpro-login-message'>Seems like your username or password has been updated on simPro, please provide us with the new details.</p>
                                                    {this.props.simproErrorMessage &&  this.props.simproErrorMessage != "" ? <div><div className="error-icon">
                                <i class="zmdi zmdi-mood-bad"></i>
                              </div><p>Failed to update simpro Details</p></div>:''}
                                                  </Col>
                                                </Row>
                                                <Row>
                                                    
                                                </Row>
                                              </Col>
                                              <Col md={12}>
                                                <Row>
                          <Col md={12}>
                                                        <TextField
                                                            hintText="Enter your simPRO username"
                                                            fullWidth={ true }
                                                            floatingLabelFixed={true}
                                                            name='simpro_username'
                                                            errorText={this.state.simpro_name_req}
                                                            onChange={this.simPROUser}
                                                            readOnly
                                                            onFocus={this.handleFocus}
                                                        />
                                                    </Col>
                                                    <Col md={12}>
                                                        <TextField
                                                            hintText="Enter your simPRO Password"
                                                            fullWidth={ true }
                                                            floatingLabelFixed={true}
                                                            name='simpro_password'
                                                            type="password"
                                                            errorText={this.state.simpro_pass_req}
                                                            onChange={this.simPROpassword}
                                                            readOnly
                                                            onFocus={this.handleFocus}
                                                        />
                                                    </Col>
                            {/* <Col md={12}>                            
                            <RaisedButton type='Submit' label={this.props.simproUpdating?<CircularProgress size={32} color="#fff"/>:"Update"} onClick = {this.authorizeApi} labelColor="#fff" fullWidth={true} />
                            
                            <RaisedButton type='Submit' label={"Cancel"} onClick = {this.cancelSimproUpdate} labelColor="#fff" className="mt-5" fullWidth={true} />
                            </Col> */}
                                                </Row>
                                                </Col>
                                            </form>
                                        </Row>
                  </div>
                </Col>
              </Row>
            </Dialog>:''
          }
          {this.props.jobs.tokenStatus === 1 && this.props.signup.disableaAuthorizeButton === false 
          ? <Dialog
              actions={action1}
              className="model-support"
              modal={true}
              open={this.state.authorizeModal}
              onRequestClose={this.closeModal}
              contentClassName="model-top-overlay no-overlay"
            >
              <Row>
                  <Col md={12}>
                        <div style={{textAlign: 'center'}} >
                        <p>Your simPRO access has expired.</p>
                        </div>
                  </Col>
              </Row>
            </Dialog>
          : null}
          {this.props.signup.disableaAuthorizeButton === true 
          ? <Dialog
              className="model-support"
              modal={false}
              open={ this.state.authorizeLoader}
              contentClassName="model-top-overlay no-overlay"
            >
              <Row>
                <Col md={12}>
                  <div style={{textAlign: 'center'}} onClick={this.closeModal} >
                    <div className="progressbar1">
                      <LinearProgress mode="indeterminate" />
                    </div>
                    <p>Processing, please wait...</p>
                  </div>
                </Col>
              </Row>
            </Dialog>
          : null}
          <div className="no-data-div">
            <p>Jobs have been imported but have not been completed will show here.</p>
          </div>
        </div>
      </div>
    </div>
  )} />     
</div>
      )
    }
} 

const mapStateToProps= (state,props)=> {
  return {
    jobs: state.jobs,
    isImporting: state.jobs.isImporting,
    importedJobId: state.jobs.importedJobId,
    importError: state.jobs.error,
    errorMessage: state.jobs.errorMessage,
    failedStockAttachments: state.jobs.failedStockAttachments,
		failedAttachments: state.jobs.failedAttachments,
    success: state.jobs.success,
    currentuser : state.login,
    notifications: state.notifications,
    subscriptionPlan: state.subscription,
    currentuser : state.login,
    signup: state.signup,
    templates: state.templates,
    simproAuthenticationFailed: state.jobs.simproAuthenticationFailed,
		simproUpdating: state.jobs.simproUpdating,
		simproUpdated: state.jobs.simproUpdated,
		simproErrorMessage: state.jobs.errorMessagesimpro,
  };
}
export default withRouter(connect(mapStateToProps,actions)(Job));


// WEBPACK FOOTER //
// ./src/Components/Pages/Job.js